import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/** Password field with a show/hide eye toggle. */
export const PasswordInput = ({ className = "", testid = "password-input", ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={show ? "text" : "password"}
        data-testid={testid}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
        data-testid={`${testid}-toggle`}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-[#06B6D4] transition-colors"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
